export const ATLAS_ASSETS_API_ENDPOINT = `/atlas-assets`;
export const ATLAS_RESPONSE_ELEMENT_ID = 'atlas-wrapper';
